import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { autoGrowLayout } from '../../../actions/editor';

import _ from 'lodash';

import { WidgetsContext } from '../core';

export const AutoGrowLayout = React.forwardRef(({ editorSession, breakpoint, widget, children, inlineAsset }, ref) => {
  const dispatch = useDispatch();
  const resizeObserverRef = React.useRef(null);
  const snapshotRef = React.useRef(null);

  const context = React.useContext(WidgetsContext);

  const id = _.get(widget, 'uid');

  useEffect(() => {
    attachResizeObserver();

    return () => {
      if (resizeObserverRef.current && ref.current) {
        resizeObserverRef.current.unobserve(ref.current);
      }
    }
  }, [breakpoint]);

  const attachResizeObserver = () => {
    if (!ref.current || context.development) {
      console.warn(`Target not found`);
      return;
    }

    resizeObserverRef.current = new ResizeObserver(entries => {
      captureSnapshot();
    });

    resizeObserverRef.current.observe(ref.current);
  }

  const captureSnapshot = () => {
    if (!ref.current || context.development) {
      return;
    }

    var height = ref.current.offsetHeight;
    const deviceSnapshot = _.get(snapshotRef.current, breakpoint);

    if (deviceSnapshot) {
      const previousHeight = _.get(deviceSnapshot, `height`, 0);

      // if (inlineAsset) {
      //   height = height - previousHeight;
      // }

      const delta = height - previousHeight;

      if (delta == 0) {
        return;
      }

      dispatch(autoGrowLayout(editorSession, breakpoint, id, delta));
    }

    snapshotRef.current = {
      ...snapshotRef.current || {},
      [breakpoint]: {
        height: height
      }
    }
  };

  return children;
});
